// 多选——主流程
const MainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `module/checkbox/index${i + 1}`,
  name: `module/checkboxIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/checkbox/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 多选——主流程，开始
    ...MainRoutes
  ]
}
